export default "__VITE_ASSET__BVLte2I6__"